import React, { useEffect, useState } from 'react';
import { Table, Tooltip, Whisper, InputGroup } from 'rsuite';
import CurrencyFormat from 'react-currency-format';
import { LoadingSpinerArea } from '../../../../../../../components/LoadingSpinner';
import { InputCurrency } from '../../../../../../../components';
import styles from './ProductDetailTable.module.scss';

type ProductDetailTableProps = {
  productDetailing: any;
  tableData: any;
  hasOpen: boolean;
  onChangeRules: (name: string, id: number, value: number) => void;
};

const { Column, HeaderCell, Cell, Pagination } = Table;

const lengthMenu = [
  {
    value: 10,
    label: 10,
  },
  {
    value: 20,
    label: 20,
  },
];

export const ProductDetailTable = ({ productDetailing, tableData, hasOpen, onChangeRules }: ProductDetailTableProps) => {
  const [reloadStyle, setReloadStyle] = useState({});

  const handleChangeRules = (name: string, id: number, value: number) => {
    onChangeRules(name, id, value);
  };

  useEffect(() => {
    if (hasOpen) {
      setReloadStyle({ margin: '0 1px' });
      setTimeout(() => {
        setReloadStyle({ margin: '0' });
      }, 100);
    }
  }, [hasOpen]);

  return (
    <div className={styles.table}>
      <LoadingSpinerArea area="table-scenario" />
      <Table
        id="table-negociacoes-fornecedor"
        className={styles['table-new-price']}
        rowClassName={styles['table-new-price-row']}
        autoHeight
        rowHeight={64}
        headerHeight={34}
        style={reloadStyle}
        data={tableData?.content || []}
        loading={productDetailing.isLoadingProductDetailing}
        sortColumn={productDetailing.productListSort.column}
        sortType={productDetailing.productListSort.type}
        onSortColumn={productDetailing.handleChangeProductDetailingColumnSort}
      >
        <Column sortable flexGrow={2}>
          <HeaderCell>Produto</HeaderCell>
          <Cell dataKey="produto" height={60}>
            {rowData => (
              <Whisper delayShow={0.2} trigger="hover" placement="bottom" speaker={<Tooltip>{rowData?.produto?.descricaoProduto}</Tooltip>}>
                <div>
                  <div className={styles.flex}>
                    <p className={[styles[rowData?.selected ? 'text-14' : 'disabled-text-14'], styles.bold].join(' ')}>
                      {rowData?.produto?.codigoInternoProduto}
                    </p>
                    <div className={styles.leader}>Líder</div>
                  </div>
                  <p className={[styles[rowData?.selected ? 'text-12' : 'disabled-text-12'], styles.bold].join(' ')}>{rowData?.produto?.descricaoProduto}</p>
                </div>
              </Whisper>
            )}
          </Cell>
        </Column>
        <Column sortable flexGrow={1}>
          <HeaderCell>Família</HeaderCell>
          <Cell dataKey="familia" height={60}>
            {rowData => (
              <div className={styles.flex}>
                <p className={[styles[rowData?.selected ? 'text-14' : 'disabled-text-14'], styles.bold].join(' ')}>{rowData?.produto?.categoriaNivel1}</p>
              </div>
            )}
          </Cell>
        </Column>
        <Column sortable flexGrow={1}>
          <HeaderCell>
            <span className={styles['flex-column']}>
              <p>Tabela base</p>
            </span>
          </HeaderCell>
          <Cell dataKey="tabelaBase">
            {rowData => (
              <div>
                <p className={styles[rowData?.selected ? 'bold' : 'disabled-text-14']}>
                  <CurrencyFormat
                    fixedDecimalScale={true}
                    decimalScale={2}
                    value={rowData?.parametros?.precoTabela}
                    displayType={'text'}
                    prefix={'R$ '}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                  />
                </p>
                <span className={styles[rowData?.selected ? 'text-11' : 'disabled-text-11']}>
                  $ {(rowData?.parametros?.margemOperacional * 100).toFixed(1).replace('.', ',')}%
                </span>
              </div>
            )}
          </Cell>
        </Column>
        <Column sortable flexGrow={1}>
          <HeaderCell>Percentual</HeaderCell>
          <Cell dataKey="percentual">
            {rowData => (
              <div className={styles.flex}>
                <InputGroup className={styles['input-group']}>
                  <InputCurrency
                    className={styles['currency-input']}
                    value={rowData?.percentual || 0}
                    disabled={!rowData?.selected}
                    precision="1"
                    decimalSeparator=","
                    thousandSeparator="."
                    onChangeEvent={(_e, _s, value) => handleChangeRules('percentual', rowData?.id, value)}
                  />
                  <InputGroup.Addon>%</InputGroup.Addon>
                </InputGroup>
              </div>
            )}
          </Cell>
        </Column>
        <Column sortable flexGrow={1}>
          <HeaderCell>Desconto máximo</HeaderCell>
          <Cell dataKey="descontoMaximo">
            {rowData => (
              <div className={styles.flex}>
                <InputGroup className={styles['input-group']}>
                  <InputCurrency
                    className={styles['currency-input']}
                    value={rowData?.descontoMaximo || 0}
                    disabled={!rowData?.selected}
                    precision="1"
                    decimalSeparator=","
                    thousandSeparator="."
                    onChangeEvent={(_e, _s, value) => handleChangeRules('descontoMaximo', rowData?.id, value)}
                  />
                  <InputGroup.Addon>%</InputGroup.Addon>
                </InputGroup>
              </div>
            )}
          </Cell>
        </Column>
      </Table>
      <Pagination
        activePage={tableData?.page?.number + 1 || null}
        displayLength={tableData?.page?.size}
        total={tableData?.page?.totalElements || null}
        onChangePage={productDetailing.handleChangeProductDetailingPage}
        onChangeLength={productDetailing.handleChangeProductDetailingLength}
        lengthMenu={lengthMenu}
      />
    </div>
  );
};
